/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

export interface SplitButtonPopoverProps {
  children: React.ReactElement | React.ReactElement[];
}

/**
 * `SplitButton.Popover` subcomponent.
 * Collects incoming props `SplitButton` may use to render a `Popover`.
 */
const SplitButtonPopover = ({ children }: SplitButtonPopoverProps) => <></>;

export default SplitButtonPopover;
